export interface IInvestmentAssociate {
    id: Number | undefined,
    prelimApplicationId: Number | undefined,
    title: String | undefined,
    name: String | undefined,
    designation: String | undefined,
    age: Number | undefined,
    qualification: String | undefined,
    investmentExperience: Number | undefined,
    description: String | undefined,
    areaOfExpertise: String | undefined
}

export const defaultInvestmentAssociate: IInvestmentAssociate = {
    id: undefined,
    prelimApplicationId: undefined,
    title: undefined,
    name: undefined,
    designation: undefined,
    age: undefined,
    qualification: undefined,
    investmentExperience: undefined,
    description: undefined,
    areaOfExpertise: undefined
}  